import React from "react";
import styles from "./anchor.module.scss";
import LightweightIcon from "../icon/LightweightIcon";
const LightweightAnchor = ({ className = "", children, href, target, icon, disableFocusOutline = false, rel }) => {
    return (React.createElement("div", { className: className },
        React.createElement("a", { className: `${styles.vhvAnchorElement} ${disableFocusOutline ? styles.noFocusOutline : ""}`, href: href, target: target, rel: rel },
            icon && React.createElement(LightweightIcon, { icon: icon }),
            children)));
};
export default LightweightAnchor;
